(function () {
  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stickyHeader = document.querySelector('.rsi-desktop-header');
  var searchInput = stickyHeader && stickyHeader.querySelector('[data-rsi-placeholder-examples]');
  var megaItems = stickyHeader ? Array.prototype.slice.call(stickyHeader.querySelectorAll('[data-rsi-mega-item]')) : [];
  var activeMegaItem = null;
  var megaCloseTimer = null;
  var stickyStart = 0;
  var rotateTimer = null;
  var placeholderIndex = 0;

  function isDesktop() {
    return desktopQuery.matches;
  }

  function calculateStickyStart() {
    if (!stickyHeader) return;
    stickyHeader.classList.remove('rsi-desktop-header--stuck');
    stickyStart = stickyHeader.getBoundingClientRect().top + window.pageYOffset;
    updateStickyState();
  }

  function updateStickyState() {
    if (!stickyHeader) return;

    if (!isDesktop()) {
      stickyHeader.classList.remove('rsi-desktop-header--stuck');
      closeAllMegaMenus();
      return;
    }

    var isStuck = window.pageYOffset > stickyStart;
    stickyHeader.classList.toggle('rsi-desktop-header--stuck', isStuck);

    if (isStuck) {
      closeAllMegaMenus();
    }
  }

  function getPlaceholderExamples() {
    if (!searchInput) return [];

    return (searchInput.getAttribute('data-rsi-placeholder-examples') || '')
      .split('|')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function stopPlaceholderRotation() {
    if (rotateTimer) {
      window.clearInterval(rotateTimer);
      rotateTimer = null;
    }
  }

  function startPlaceholderRotation() {
    var examples = getPlaceholderExamples();

    stopPlaceholderRotation();

    if (!searchInput || !isDesktop() || reducedMotionQuery.matches || examples.length < 2 || searchInput.value) {
      return;
    }

    rotateTimer = window.setInterval(function () {
      if (document.activeElement === searchInput || searchInput.value) {
        stopPlaceholderRotation();
        return;
      }

      placeholderIndex = (placeholderIndex + 1) % examples.length;
      searchInput.setAttribute('placeholder', examples[placeholderIndex]);
    }, 3000);
  }

  function getMegaTrigger(item) {
    return item && item.querySelector('[data-rsi-mega-trigger]');
  }

  function getMegaMenu(item) {
    return item && item.querySelector('[data-rsi-mega-menu]');
  }

  function setMegaState(item, isOpen) {
    var trigger = getMegaTrigger(item);
    var menu = getMegaMenu(item);

    if (!trigger || !menu) return;

    item.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    menu.hidden = !isOpen;
    menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  function closeMegaMenu(item) {
    if (!item) return;

    setMegaState(item, false);

    if (activeMegaItem === item) {
      activeMegaItem = null;
    }
  }

  function closeAllMegaMenus(exceptItem) {
    if (megaCloseTimer) {
      window.clearTimeout(megaCloseTimer);
      megaCloseTimer = null;
    }

    megaItems.forEach(function (item) {
      if (item !== exceptItem) {
        closeMegaMenu(item);
      }
    });
  }

  function openMegaMenu(item) {
    if (!item || !isDesktop()) return;

    closeAllMegaMenus(item);
    activeMegaItem = item;
    setMegaState(item, true);
  }

  function scheduleMegaClose(item) {
    if (megaCloseTimer) {
      window.clearTimeout(megaCloseTimer);
    }

    megaCloseTimer = window.setTimeout(function () {
      if (!item.matches(':hover') && !item.contains(document.activeElement)) {
        closeMegaMenu(item);
      }
    }, 120);
  }

  function handleMegaMouseEnter(event) {
    openMegaMenu(event.currentTarget);
  }

  function handleMegaMouseLeave(event) {
    scheduleMegaClose(event.currentTarget);
  }

  function handleMegaFocusIn(event) {
    openMegaMenu(event.currentTarget);
  }

  function handleMegaFocusOut(event) {
    if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
      return;
    }

    scheduleMegaClose(event.currentTarget);
  }

  function handleMegaKeydown(event) {
    if (event.key !== 'Escape') return;

    event.preventDefault();
    closeMegaMenu(event.currentTarget);

    var trigger = getMegaTrigger(event.currentTarget);
    if (trigger) {
      trigger.focus();
    }
  }

  function handleDesktopQueryChange() {
    calculateStickyStart();
    closeAllMegaMenus();
  }

  if (stickyHeader) {
    calculateStickyStart();
    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', calculateStickyStart);

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', handleDesktopQueryChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(handleDesktopQueryChange);
    }
  }

  megaItems.forEach(function (item) {
    item.addEventListener('mouseenter', handleMegaMouseEnter);
    item.addEventListener('mouseleave', handleMegaMouseLeave);
    item.addEventListener('focusin', handleMegaFocusIn);
    item.addEventListener('focusout', handleMegaFocusOut);
    item.addEventListener('keydown', handleMegaKeydown);
  });

  if (searchInput) {
    searchInput.addEventListener('focus', stopPlaceholderRotation);
    searchInput.addEventListener('input', stopPlaceholderRotation);
    searchInput.addEventListener('blur', startPlaceholderRotation);
    startPlaceholderRotation();
  }
})();
